import { Component, Input, OnChanges, OnInit, ViewChild } from '@angular/core';
import { ChartData, ChartOptions } from 'chart.js';
import { BaseChartDirective } from 'ng2-charts';

@Component({
  selector: 'app-bar-chart',
  templateUrl: './bar-chart.component.html',
  styleUrl: './bar-chart.component.scss'
})
export class BarChartComponent implements OnInit, OnChanges  {
  @ViewChild(BaseChartDirective) chart: BaseChartDirective | undefined;

  @Input() chartLabels: string[] = []; // Labels do eixo X
  @Input() chartData: number[] = []; // Dados das barras
  @Input() chartTitle: string = ''; // Título do gráfico

  // Dados e configurações do gráfico
  public barChartData: ChartData<'bar'> = {
    labels: [],
    datasets: [
      {
        data: [],
        label: 'Quantidade de cotas',
        backgroundColor: '#2548A3',
        hoverBackgroundColor: '#2548A3',
        barPercentage: 0.5,
        categoryPercentage: 0.5,
      },
    ],
  };

  public barChartOptions: ChartOptions<'bar'> = {
    responsive: true, // Gráfico responsivo
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        displayColors: false,
        titleColor: 'blue',
        callbacks: {
          title: () => '',
          label: (tooltipItem) => `${tooltipItem.raw} cotas`,
        },
      },
    },
    scales: {
      x: {
        grid: {
          display: true,
          offset: false
        },
        ticks: {
          align: 'center',
          font: {
            size: window.innerWidth < 500 ? 12 : 14,
          },
          callback: function(value: any) {
            const label = this.getLabelForValue(value);
            const isMobile = window.innerWidth < 500;
            const maxCharsPerLine = isMobile ? 15 : 20;
    
            const words = label.split(' ');
            let currentLine = '';
            const lines = [];
    
            words.forEach(word => {
              if ((currentLine + word).length > maxCharsPerLine) {
                lines.push(currentLine.trim());
                currentLine = word + ' ';
              } else {
                currentLine += word + ' ';
              }
            });
    
            if (currentLine) {
              lines.push(currentLine.trim());
            }
    
            return lines; 
          }
        },
        type: 'category'
      },
      y: {
        beginAtZero: true,
        suggestedMin:0,
        ticks: {
          stepSize: 10,
          autoSkip: true,
        },
        grid: {
          drawTicks: true,
          lineWidth: 1, 
        }
      },
    },
    
  };

  constructor() {}

  ngOnInit(): void {
    this.updateChart();
  }

  // Atualiza os dados do gráfico
  ngOnChanges(): void {
    this.updateChart();
  }

  private updateChart() {
    this.barChartData.labels = this.chartLabels;
    this.chartData.forEach(x => this.barChartData.datasets[0].data.push(x))

    this.chart?.update();
  }

}
